module.exports = __webpack_public_path__ + "media/brands/citroen-010a01fd.png";